export type ShippingFormattedAddress = {
  street1: string
  street2?: string
  city: string
  zipCode: string
  state: string
}

export enum ShippingSubRoutes {
  Preview = 'Preview',
  Edit = 'Edit',
  Validation = 'Validation',
  Error = 'Error',
}
